module.exports = __webpack_public_path__ + "img/azores-islands.621c7b77.svg";